<template>
    <div class="price-section" v-if="totalPrice.Amount !== 0">
        <div class="price-section-title">
            {{ t({ key: 'shared.seating' }) }}
        </div>
        <PriceSpecificationRow
            :price="totalPrice"
            :class="'total'"
            :description="t({ key: 'checkout.total_price_seating' })" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FlightProduct } from '@/api/Cart/cart.interfaces';
    import PriceSpecificationRow from '../PriceSpecificationRow.vue';
    import { t } from '@shared/helpers/translation';

    export default defineComponent({
        name: 'PriceSpecificationSeating',
        methods: { t },
        components: {
            PriceSpecificationRow,
        },
        props: {
            product: {
                type: Object as PropType<FlightProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const totalPrice = product?.Seating?.Price ?? {
                Amount: 0,
                Currency: '',
            };

            return {
                totalPrice,
            };
        },
    });
</script>
